import { getHeaderNavLinks } from './navLinks';
var nav = ['홈', '학습 도구', '질문 올리기', '수학 문제 해결', '작문 센터 방문'];
var secondaryNav = ['커리어'];
var userNav = ['내 계정', '수학', '작문', '도움말', '로그아웃'];
var lifePrimaryNav = ['경제', '건강 + 웰빙', '생활 기술', '리소스', '회사 소개', 'Chegg Life 검색', '도움받기'];
var qnaNav = ['지금 가입하기', '다시 구독', '재개'];
var qnaUserNav = ['내 계정', '수학', '작문', '도움말', '로그아웃'];
export default getHeaderNavLinks(nav, secondaryNav, userNav, lifePrimaryNav, qnaNav, qnaUserNav);